import { faList, faMap } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
    BoxProps,
    Box as MuiBox,
    styled,
    Typography,
    useTheme,
} from "@mui/material";
import React from "react";
import { useTranslation } from "react-i18next";
import { useLocation, useNavigate, useParams } from "react-router-dom";

import { URL_LIST_VIEW, URL_MAP_VIEW } from "src/router/routes";

const Box = styled(MuiBox)<BoxProps>(({ theme }) => ({
    height: theme.spacing(5.4),
    width: "100%",
    display: "flex",
    justifyContent: "space-around",
    alignItems: "center",
}));

const MobileSwitchView = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const location = useLocation();
    const { schema } = useParams<{ schema: string }>();
    const theme = useTheme();

    const handleNavigation = (url: string) => {
        navigate(url);
    };

    const SwitchOptions = [
        {
            icon: faMap,
            text: t("map"),
            targetUrl: `/${schema}${URL_MAP_VIEW}`,
        },
        {
            icon: faList,
            text: t("list"),
            targetUrl: `/${schema}${URL_LIST_VIEW}`,
        },
    ];

    return (
        <Box>
            {SwitchOptions.map((option) => {
                const isSelected = location.pathname === option.targetUrl;

                return (
                    <Box
                        key={option.targetUrl}
                        display="flex"
                        flexDirection="column"
                        justifyContent="center"
                        alignItems="center"
                        onClick={() => handleNavigation(option.targetUrl)}
                        sx={{
                            cursor: "pointer",
                            color: isSelected
                                ? theme.palette.primary.main
                                : theme.palette.text.primary,
                        }}
                    >
                        <Box
                            display="flex"
                            flexDirection="column"
                            alignItems="center"
                            justifyContent="center"
                        >
                            <FontAwesomeIcon
                                icon={option.icon}
                                color={
                                    isSelected
                                        ? theme.palette.primary.main
                                        : theme.palette.text.primary
                                }
                            />
                            <Typography
                                fontSize="0.7rem"
                                color={
                                    isSelected ? "primary.main" : "text.primary"
                                }
                            >
                                {option.text}
                            </Typography>
                        </Box>
                    </Box>
                );
            })}
        </Box>
    );
};

export default MobileSwitchView;
